import { defineStore } from "pinia";
import { fetchWrapper } from "@/helpers";
import { useAlertStore } from "..";

const baseUrl = `${process.env.VUE_APP_VUE_API_URL}`;

export const useAdminIspStore = defineStore("admin-isp", {
  state: () => ({
    isps: [],
  }),
  actions: {
    async loadIsps() {
      const alertStore = useAlertStore();
      try {
        const res = await fetchWrapper.get(`${baseUrl}/admin/isp/load`);
        this.isps = res.isps || [];
      } catch (error) {
        alertStore.error(error);
      }
    },
    async createIsp(formData) {
      const alertStore = useAlertStore();
      try {
        await fetchWrapper.post(`${baseUrl}/admin/isp/create`, formData);
        alertStore.success("New ISP successfully added");
      } catch (error) {
        alertStore.error(error);
      }
    },
    async updateIsp(formDataOrJson) {
      const alertStore = useAlertStore();
      try {
        await fetchWrapper.post(`${baseUrl}/admin/isp/update`, formDataOrJson);
        alertStore.success("Update successful");
      } catch (error) {
        alertStore.error(error);
      }
    },
    async deleteIsps(ids) {
      const alertStore = useAlertStore();
      try {
        await fetchWrapper.post(`${baseUrl}/admin/isp/delete`, { ids });
        alertStore.success("Delete successful");
      } catch (error) {
        alertStore.error(error);
      }
    },
  },
});

